module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("16dTV"))).then(() => parcelRequire('d0iPb'));